/**
 * Shared province list for dashboard filter MultiSelect components (value keys match API / state).
 */
export const PROVINCE_MULTISELECT_OPTIONS = [
  { label: 'Alberta', value: 'alberta' },
  { label: 'British Columbia', value: 'british_columbia' },
  { label: 'Manitoba', value: 'manitoba' },
  { label: 'New Brunswick', value: 'newBrunswick' },
  {
    label: 'Newfoundland and Labrador',
    value: 'newfoundlandAndLabrador'
  },
  { label: 'Northwest Territories', value: 'northwestTerritories' },
  { label: 'Nova Scotia', value: 'novaScotia' },
  { label: 'Nunavut', value: 'nunavut' },
  { label: 'Ontario', value: 'ontario' },
  { label: 'Prince Edward Island', value: 'princeEdwardIsland' },
  { label: 'Quebec', value: 'quebec' },
  { label: 'Saskatchewan', value: 'saskatchewan' },
  { label: 'Yukon', value: 'yukon' }
];
